module.exports = __webpack_public_path__ + "img/expand_table.svg";